import styled, { css } from 'styled-components';
import { isTablet } from 'react-device-detect';
import { isNotStandaloneMobilePWA, isStandalonePWA } from '../../../../utils/mobileSupported';
import { getResponsiveValue } from '../../../../utils/globalMethods';
import { StartMissionstepTooltipTopPosConditions, StartMissionstepTooltipTopPosConditionsTablet } from './conditions';
import { Tooltip } from '..';

const CompleteRequestMobilePWA = css`
  left: 60vh;
  top: 16vh;
`;

const tooltipSmallScreen = css`
  top: ${({ $windowHeight }) =>
    getResponsiveValue({
      windowHeight: $windowHeight,
      conditions: isTablet ? StartMissionstepTooltipTopPosConditionsTablet : StartMissionstepTooltipTopPosConditions,
      defaultValue: isTablet ? 11 : 14,
    })}vh;
  left: ${isTablet ? 45 : 52}vh;
`;

export const START_MISSION = {
  TOOLTIP: styled(Tooltip)`
    width: 48vh;
    top: 13vh;
    left: 52vh;
    ${isNotStandaloneMobilePWA && tooltipSmallScreen}
    ${isStandalonePWA && !isTablet && CompleteRequestMobilePWA}
  `,
};

